export interface AdvertViewVehicleMediaDTO {
  mediaURL?: string;
  sequence?: number;
}
